import { LocationCoreService } from '@core/services';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class MenuFlowGuard implements CanActivate {
  route: ActivatedRouteSnapshot;

  constructor(
    private locationCoreService: LocationCoreService,
    private router: Router  ) {

  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    Observable<boolean> | Promise<boolean> | boolean {
      this.route = route;
    if (state.url === '/locations/menu') {
      this.locationCoreService.checkNearestLocationAvailability('menuFlowGuard', function() {return this.assumedLocation(route)}.bind(this));
    } else {
      return true;
    }
  }
  private assumedLocation(route: ActivatedRouteSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this.locationCoreService.getAssumedLocation().then(
      (success) => {
        if (success && success.unit) {
          this.router.navigate(['/locations/' + success.unit + '/menu'], { queryParams: route.queryParams });
          return false;
        }
        return true;
      }
    ).catch((err) => {
      return true;
    });
  }
}

